import { AppsMenu, isLightBg, useTheme, type AppsMenuModule } from "@dehub/theme"

export type AppsMenuBadgeModule = Pick<AppsMenuModule, "id" | "label" | "icon" | "active" | "badge"> & { href: string }

/** Module switcher of the header: the theme's AppsMenu (UI standard) with per-module unread dots. */
export function AppsMenuWithBadge({ modules, align = "left" }: { modules: AppsMenuBadgeModule[]; align?: "left" | "right" }) {
  const { tokens } = useTheme()
  return <AppsMenu light={isLightBg(tokens.header.gradient)} modules={modules} align={align} />
}
